'use strict';
import React from 'react';
import _ from 'lodash';

/**
 * Input label component.
 * Encloses input fields and other inputs to include labels.
 *
 * Usage:
 *
 * ```Javascript
 * <InputLabel label="name" for="model-name">
 *   <InputValidation>{model.errors.name}</InputValidation>
 *   <InputField name="name" id="model-name" error/>
 * </InputLabel>
 * ```
 *
 * @extends {React.Component}
 * @property {String} label Sets the label to be rendered.
 */
class InputLabel extends React.Component {
  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, label, ...otherProps } = this.props;

    return (
      <label {...otherProps} className="InputField-label">
        {_.capitalize(label).concat(':')}
        {children}
      </label>
    );
  }
}

InputLabel.defaultProps = {
};

InputLabel.propTypes = {
  label: React.PropTypes.string.isRequired
};

export default InputLabel;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/inputField/inputLabel.jsx